import AuthHelper from 'features/Auth/authHelper';
import AccountHelper from 'features/Account/accountHelper';
import AppRoute from 'general/constants/AppRoute';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import RoleUtils from 'general/utils/RoleUtils';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

function CustomerRoute(props) {
  const isAuth = AuthHelper.checkAccessTokenValid() ?? false;
  const { user, agencyRoleList } = useSelector((state) => state.auth);
  const savedUiMode = localStorage.getItem(PreferenceKeys.savedUiMode);
  const [profileLoadFailed, setProfileLoadFailed] = useState(false);

  useEffect(() => {
    let isMounted = true;
    if (isAuth && !user?.role) {
      AccountHelper.callApiGetProfile().then((profile) => {
        if (isMounted && !profile) setProfileLoadFailed(true);
      });
    }
    return () => {
      isMounted = false;
    };
  }, [isAuth, user]);

  if (!isAuth) return <Navigate to={`${AppRoute.auth}/sign-in`} replace />;

  if (profileLoadFailed) {
    AuthHelper.signOut();
    return <Navigate to={`${AppRoute.auth}/sign-in`} replace />;
  }

  if (!user?.role) {
    return (
      <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light font-weight-bolder">
        Đang tải...
      </div>
    );
  }

  if (!RoleUtils.isCustomerUiMode(savedUiMode) && RoleUtils.hasCmsUi(user, agencyRoleList)) {
    return <Navigate to={RoleUtils.getCmsHomeRoute(user, agencyRoleList)} replace />;
  }

  return props.children;
}

export default CustomerRoute;
